export default __webpack_public_path__ + "aa5b4cf7abe6108bbf37d634cc89ca2f.webp";